/**
 * 区分 contractType（contracts.contract_type）
 * 出典：仕様書に値なし
 * 【仮置き】入力文書に値が無い。業務側の確認で差し替える
 */
export const CONTRACT_TYPE_VALUES = ['quasiMandate', 'contracting', 'dispatch'] as const;

export type ContractType = (typeof CONTRACT_TYPE_VALUES)[number];

export const CONTRACT_TYPE_LABELS: Readonly<Record<ContractType, string>> = {
  quasiMandate: '準委任',
  contracting: '請負',
  dispatch: '派遣',
};
